module.exports = __webpack_public_path__ + "static/phone-02-87280437591ad003ea72a65faefc7dc9.png";